import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useEffect, useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";

export function RecaptchaView() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { updateCaptcha } = useContext(AuthContext);

  useEffect(() => {
    const runCaptcha = async () => {
      if (!executeRecaptcha) return;

      const token = await executeRecaptcha("login_verification");

      if (token) {
        updateCaptcha(true); // ✅ Token automático
      } else {
        updateCaptcha(false);
      }
    };

    runCaptcha();
  }, [executeRecaptcha, updateCaptcha]);

  return null; // ✅ No renderiza nada
}
